import AlertTriangle from '@/assets/icons/alert-triangle'
import { Button } from '@/components'
import PropTypes from 'prop-types'

const StaticAnnouncement = ({ startIcon, text, action, noShadow }) => {
  return (
    <div
      className={`rounded-xl h-auto border-[--neutral-50] bg-white border-[1px] flex flex-col md:flex-row items-center justify-between px-3 py-4 ${noShadow ? '' : 'shadow-[0px_15px_30px_-20px_rgba(0,0,0,0.3)]'}`}
    >
      <div className="flex flex-row items-center justify-start">
        {startIcon ? (
          <img
            src={startIcon}
            alt="announcement-icon"
            width={48}
            height={48}
            className={noShadow ? 'shadow-none' : undefined}
          />
        ) : null}
        {text && <span className="font-normal text-base ml-2 md:ml-4 text-neutral-700">{text}</span>}
      </div>
      {Boolean(action) && <div className="md:w-auto w-full my-4 md:m-0 md:pl-1">{action}</div>}
    </div>
  )
}

const StaticAnnouncementError = ({ text, action }) => {
  return (
    <div className="rounded-xl h-auto border-error-500 bg-[--error-50] border-[1px] flex flex-col md:flex-row items-center justify-between px-3 py-4">
      <div className="flex flex-row items-center justify-start">
        <div className="w-[48px] h-[48px] bg-white rounded-[10px] border border-[#EAECF0] flex items-center justify-center flex-shrink-0">
          <AlertTriangle />
        </div>
        {text && <span className="font-regular text-base ml-2 md:ml-4 text-neutral-900">{text}</span>}
      </div>
      <div className="md:w-auto w-full my-4 md:m-0 md:pl-1">{action ? action : null}</div>
    </div>
  )
}

const StaticAnnouncementErrorMini = ({ text, action }) => {
  return (
    <div className="rounded-xl bg-[--error-50] flex flex-col md:flex-row items-start md:items-center justify-between px-2 py-2">
      <div className="flex flex-row items-center">
        <div className="w-[32px] h-[32px] md:w-[48px] md:h-[48px] bg-white rounded-[10px] border border-[#EAECF0] flex items-center justify-center flex-shrink-0">
          <AlertTriangle />
        </div>
        {text && <span className="font-regular text-xs ml-2 md:ml-4 text-neutral-900 leading-relaxed">{text}</span>}
      </div>
      {action && <div className="md:w-auto w-full my-4 md:m-0 md:pl-1">{action}</div>}
    </div>
  )
}

const StaticAnnouncementAction = ({ id, text, handleClick, disabled }) => {
  return (
    <Button
      id={id}
      aria-label={text}
      variant="outlineSecondary"
      className={`font-semibold text-neutral-700 text-md w-full border-[--neutral-100] ${disabled ? 'hover:bg-white' : 'hover:bg-dGray-100'}`}
      onClick={handleClick}
    >
      {text}
    </Button>
  )
}

StaticAnnouncement.propTypes = {
  startIcon: PropTypes.string,
  text: PropTypes.node,
  action: PropTypes.node,
  noShadow: PropTypes.bool,
}

StaticAnnouncementError.propTypes = {
  text: PropTypes.node,
  action: PropTypes.node,
}

StaticAnnouncementErrorMini.propTypes = {
  text: PropTypes.node,
  action: PropTypes.node,
}

StaticAnnouncementAction.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
  handleClick: PropTypes.func,
  disabled: PropTypes.bool,
}

export { StaticAnnouncement, StaticAnnouncementAction, StaticAnnouncementError, StaticAnnouncementErrorMini }
